import styled from "@emotion/styled";
import { useTheme } from "@mui/material";
import { Skeleton } from "@kaltura/mediaspace-shared-styled";

const StyledDetailsSkeleton = styled("div")(({ theme }) => ({
    paddingTop: theme.spacing(1),
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(1),
}));

const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
    borderRadius: theme.kaltura.shape.roundness1,
}));

/**
 * search result details skeleton
 */
export function DetailsSkeleton() {
    const theme = useTheme();

    return (
        <StyledDetailsSkeleton>
            <StyledSkeleton variant="rectangular" height={theme.spacing(2)} width={"100%"} />

            <StyledSkeleton variant="rectangular" height={theme.spacing(2)} width={"60%"} />

            <StyledSkeleton variant="rectangular" height={theme.spacing(2)} width={"80%"} />
        </StyledDetailsSkeleton>
    );
}

export default DetailsSkeleton;
